import React from 'react';

const GenericPage = () => (
  <div>Generic Page</div>
  );

export default GenericPage;



// WEBPACK FOOTER //
// ./src/components/pages/GenericPage/index.js